// Find the lowest tier in the variants array and ensure that the first variant
// is the lowest tier. E.g. if the lowest tier is tier 1, then check if the
// first variant is a tier 1 variant - if it is not, then move the first tier 1
// variant found to the start of array.
const getLowestTierVariantFirst = (variants = []) => {
  const lowestTier = variants.reduce((lowestTierSoFar, variant) => {
    const { tier } = variant;

    return tier < lowestTierSoFar || lowestTierSoFar === null
      ? tier
      : lowestTierSoFar;
  }, null);

  if (lowestTier === null) {
    return variants;
  }

  const firstLowestTierVariant = variants.find(
    option => option.tier === lowestTier
  );

  const firstLowestTierVariantId = firstLowestTierVariant.id;

  const variantsWithoutFirstLowestTierVariant = variants.filter(
    variant => variant.id !== firstLowestTierVariantId
  );

  return [firstLowestTierVariant, ...variantsWithoutFirstLowestTierVariant];
};

export default getLowestTierVariantFirst;
